import { Box, Button, Grid, Typography } from '@mui/material'
import { AppContainer } from '@shared/components/AppContainer';
import { Link, useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { TokenCategories } from '@shared/components/TokenCategories';
import TokenCard from '@shared/components/TokenCard';
import { useEffect } from 'react';
import { getCategoriesAction, getTokensByCategoryAction, tokenSelector } from '@store/slices/token.slice';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import TokenCardSkeleton from '@shared/skeletons/TokenCardSkeleton';
import { appSelector } from '@store/slices/app.slice';
import { CustomPagination } from '@shared/components/CustomPagination';
import { PAGINATION_LIMIT } from '@shared/constants/app.constant';
import { Pagination } from '@interfaces/pagination';
import { FeaturedTokens } from './components/FeaturedTokens';
import { AppNoToken } from '@shared/components/AppNoToken';
import ExploreIcon from '@mui/icons-material/Explore';

export const BrowseToken = () => {
    let history = useHistory();
    let { id } = useParams<{ id: string }>();
    const tokensSlice = useAppSelector(tokenSelector)
    const appSlice = useAppSelector(appSelector)
    const dispatch = useAppDispatch();

    const onTokenSelect = (id: number) => {
        history.push(`/public/token/${id}?owned=${false}`)
    }

    const getTokens = (pagination: Pagination) => {
        dispatch(getTokensByCategoryAction({ id, pagination }));
    }
    const getCategory = () => {
        const category = tokensSlice.categories.find(x => Number(x.id) === Number(id));
        if (category) {
            return category?.name;
        }

    }

    useEffect(() => {
        if (tokensSlice.categories.length == 0) {
            dispatch(getCategoriesAction())
        }
        getTokens({ page: 1, limit: PAGINATION_LIMIT })

    }, [id])

    return (
        <AppContainer>
            <FeaturedTokens />
            <TokenCategories categories={tokensSlice.categories} selectedIndex={id} />
            {appSlice.loading && (
                <Box my={4}>
                    <Grid container spacing={2} >
                        {[1, 2, 3, 4, 5, 6].map(item => (
                            <Grid item md={4} xs={12} key={item}>
                                <TokenCardSkeleton />
                            </Grid>
                        ))
                        }
                    </Grid>
                </Box>
            )}
            {tokensSlice.categoryTokens?.data?.length > 0 && (
                <>
                    <Box my={4}>
                        <Typography gutterBottom variant="h5" component="div">
                            <strong> {getCategory()}</strong>
                        </Typography>
                    </Box>
                    <Grid container spacing={4} >
                        {tokensSlice.categoryTokens?.data?.map(token => {
                            return (
                                <Grid item md={4} xs={12} key={token.id}>
                                    <TokenCard token={token} click={onTokenSelect} />
                                </Grid>
                            )
                        })}
                    </Grid>
                    {tokensSlice.categoryTokens?.data?.length > 0 && (
                        <CustomPagination pagination={tokensSlice?.categoryTokens?.meta} change={getTokens} />
                    )}
                </>
            )}

            {(!appSlice.loading && (!tokensSlice.categoryTokens?.data || tokensSlice.categoryTokens?.data?.length == 0)) && (
                <Box mt={16}>
                    <AppNoToken
                        title="There are no Memberships available in this category" body={'Explore the market by clicking the button below.'}>
                        <Box my={3}>
                            <Button size="large" component={Link} to={`/marketplace`} color="primary" variant="contained" >
                                <ExploreIcon /> &nbsp;&nbsp; Explore marketplace
                            </Button>
                        </Box>
                    </AppNoToken>
                </Box>
            )}

        </AppContainer>
    )
}
